import React from "react";
import { default as Icon } from "../icon/index";
export default Icon;

export const Icons = {};
